import useAuth from "./useAuth";
import { KeycloakTokenParsed } from "keycloak-js";
import keycloakInstance from "@/initKeycloak";

/**
 * Generic RBAC hook that checks if the authenticated user has a specific role.
 *
 * Reads from the reactive `tokenParsed` store value (not the keycloak instance)
 * so that role changes are picked up after token refresh.
 *
 * @param role - The role name to check for
 * @param resource - Resource/client name. When omitted, defaults to keycloak clientId
 *                   (matching keycloak-js hasResourceRole behaviour).
 * @returns boolean - true if user has the role, false otherwise
 */
export const useHasRole = (role: string, resource?: string) => {
  const { authenticated, tokenParsed } = useAuth();

  if (!authenticated || !tokenParsed) return false;

  const parsed = tokenParsed as KeycloakTokenParsed;
  const effectiveResource = resource ?? keycloakInstance.clientId;

  if (!effectiveResource) return false;

  const roles = parsed.resource_access?.[effectiveResource]?.roles ?? [];
  return roles.includes(role);
};
